module.exports = __webpack_public_path__ + "img/engineering__crane.b7a6e59f.svg";